var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgA1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.09 22.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2824038914688",
    "data-name": 2824038914688
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.52,0h27A1.52,1.52,0,0,1,30,1.52h0A1.52,1.52,0,0,1,28.47,3H1.52A1.52,1.52,0,0,1,0,1.52H0A1.53,1.53,0,0,1,1.52,0Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52,9.51h27A1.52,1.52,0,0,1,30,11h0a1.52,1.52,0,0,1-1.51,1.52H1.52A1.53,1.53,0,0,1,0,11H0A1.52,1.52,0,0,1,1.52,9.51Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52,19.71H28.57a1.53,1.53,0,0,1,1.52,1.52h0a1.53,1.53,0,0,1-1.52,1.52h-27A1.53,1.53,0,0,1,0,21.23H0A1.53,1.53,0,0,1,1.52,19.71Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA1);
export default __webpack_public_path__ + "static/media/A1.f366059e57701575bc6a42d0cb02cd87.svg";
export { ForwardRef as ReactComponent };